
const pageScroll = {}

export default function () {
  const storePageScrollPosition = () => {
    if (typeof window !== 'undefined') {
      pageScroll[location.href] = window.scrollY
    }
  }

  const restorePageScrollPosition = () => {
    if (typeof window !== 'undefined') {
      setTimeout(() => {
        window.scroll(0, pageScroll[location.href] || 0)
      }, 100)
    }
  }

  return {
    storePageScrollPosition,
    restorePageScrollPosition
  }
}
